module.exports = __webpack_public_path__ + "fbb53502175de4260ab7f918937f60a3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/2.png
// module id = 32
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18